import React, { useEffect } from "react";
import "./Faq.css";
import { useDispatch, useSelector } from "react-redux";
import { AllBenefits } from "../../../features/master/masterSlice";

function Faq() {
  const benefits = useSelector((state) => state.master.benefits);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(AllBenefits());
  }, [dispatch]);
  return (
    <>
      <section className="Faq">
        <div className="container-fluid">
          {benefits?.map((val) => (
            <div className="text_holder">
              <h4>{val?.name}</h4>
              <p>
                {val?.description}
              </p>
            </div>
          ))}
          {/* <div className="text_holder">
            <h4>Benefits of Using Rishigram's Best-Selling Products</h4>
            <p>
              While the best way to retain essential nutrients is to buy chakki
              fresh atta online, Rishigram Khapli atta stands out with 50%
              higher fiber content. This makes it an excellent choice for those
              looking to lose weight, improve digestion, and boost overall
              wellness—all while enjoying the authentic taste of traditional
              grains.
            </p>
          </div>
          <div className="text_holder">
            <h4>Benefits of Using Rishigram's Best-Selling Products</h4>
            <p>
              While the best way to retain essential nutrients is to buy chakki
              fresh atta online, Rishigram Khapli atta stands out with 50%
              higher fiber content. This makes it an excellent choice for those
              looking to lose weight, improve digestion, and boost overall
              wellness—all while enjoying the authentic taste of traditional
              grains.
            </p>
          </div> */}
        </div>
      </section>
    </>
  );
}

export default Faq;
